import React from 'react';
import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { makeStyles, Typography } from '@material-ui/core';

const useStyle = makeStyles({
  radioLabel: {
    fontFamily: 'Lato',
    fontWeight: '500',
    fontSize: '12px',
  },
});

const CustomRadioGroup = ({ handleChange, options, name, value, disabled }) => {
  const classes = useStyle();

  return (
    <FormControl>
      <RadioGroup
        row
        aria-labelledby="demo-radio-buttons-group-label"
        value={value}
        name={name}
        onChange={handleChange}
      >
        {options?.map((option) => (
          <FormControlLabel
            key={option?.name}
            value={option?.value}
            disabled={disabled}
            control={
              <Radio
                sx={{
                  color: 'rgba(208, 213, 221, 1)',
                  '&.Mui-checked': {
                    color: 'rgba(98, 47, 238, 1)',
                  },
                  '&.Mui-disabled': {
                    color: 'rgba(169, 169, 169, 1)',
                  },
                }}
              />
            }
            label={<Typography className={classes.radioLabel}>{option?.name}</Typography>}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default React.memo(CustomRadioGroup);
